export const CATEGORY_ITEMS = [
  {
    label: "सामान्य",
    slug: "general",
    category: "General",
    dbName: "सामान्य",
    aliases: ["general", "सामान्य"],
  },
  {
    label: "राजनीति",
    slug: "politics",
    category: "राजनीति",
    dbName: "राजनीति",
    aliases: ["politics", "राजनीति"],
  },
  {
    label: "खेल",
    slug: "sports",
    category: "खेल",
    dbName: "खेल",
    aliases: ["sports", "sport", "khel", "खेल"],
  },
  {
    label: "देश",
    slug: "desh",
    category: "देश",
    dbName: "राष्ट्रीय",
    aliases: ["देश", "national", "राष्ट्रीय"],
  },
  {
    label: "विदेश",
    slug: "videsh",
    category: "विदेश",
    dbName: "विदेश",
    aliases: ["विदेश", "international", "world"],
  },
  {
    label: "स्वास्थ्य",
    slug: "health",
    category: "स्वास्थ्य",
    dbName: "स्वास्थ्य",
    aliases: ["health", "healthcare", "स्वास्थ्य", "स्वास्थ्य/लाइफस्टाइल", "लाइफस्टाइल"],
  },
  {
    label: "धर्म",
    slug: "dharm",
    category: "धर्म",
    dbName: "धर्म",
    aliases: ["धर्म", "religion", "धर्म/ज्योतिष", "ज्योतिष"],
  },
  {
    label: "सिनेमा",
    slug: "cinema",
    category: "सिनेमा",
    dbName: "मनोरंजन",
    aliases: ["सिनेमा", "cinema", "entertainment", "मनोरंजन"],
  },
  {
    label: "विज्ञान और प्रौद्योगिकी",
    slug: "science-technology",
    category: "विज्ञान और प्रौद्योगिकी",
    dbName: "टेक/विज्ञान",
    aliases: [
      "science",
      "technology",
      "science and technology",
      "sci-tech",
      "विज्ञान",
      "प्रौद्योगिकी",
      "विज्ञान और प्रौद्योगिकी",
      "टेक/विज्ञान",
    ],
  },
  {
    label: "व्यापार",
    slug: "business",
    category: "व्यापार",
    dbName: "व्यापार",
    aliases: ["business", "व्यापार", "economy", "finance"],
  },
];

export const normalize = (s) => (s || "").toLowerCase().trim();

export const getCategoryBySlug = (slug) =>
  CATEGORY_ITEMS.find(
    (item) =>
      item.slug === slug ||
      (item.aliases || []).map(normalize).includes(normalize(slug))
  );

// URL slug → Devanagari subcategory name (as stored in the backend DB)
export const SUBCATEGORY_SLUG_MAP = {
  state: "राज्य",
  district: "जिला",
  local: "लोकल न्यूज़",
  "local-news": "लोकल न्यूज़",
  election: "चुनाव",
  economy: "इकनॉमी",
  "stock-market": "शेयर बाजार",
  finance: "फाइनेंस",
  "real-estate": "रियल एस्टेट",
  movies: "फिल्में",
  "tv-shows": "टीवी शो",
  ott: "ओटीटी (OTT)",
  celebrity: "सेलिब्रिटी",
  cricket: "क्रिकेट",
  football: "फुटबॉल",
  olympics: "ओलंपिक",
  spirituality: "आध्यात्मिकता",
  astrology: "ज्योतिष",
  horoscope: "राशिफल",
  fitness: "फिटनेस",
  medical: "मेडिकल",
  fashion: "फैशन",
  travel: "यात्रा",
  food: "भोजन",
  crime: "अपराध",
  education: "शिक्षा",
  jobs: "नौकरियां",
  agriculture: "कृषि",
  automobile: "ऑटोमोबाइल",
  weather: "मौसम",
  opinion: "ओपिनियन",
};
